import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Sparkles } from 'lucide-react';
import { useSharedStore } from '../../hooks/useSharedStore';
import { isModuleOn, salesOf, ORG_TYPES } from '../../data/store';

// Import all dashboard modules
import { PosModule } from './dashboard/PosModule';
import { CatalogModule } from './dashboard/CatalogModule';
import { InventoryModule } from './dashboard/InventoryModule';
import { PurchaseModule } from './dashboard/PurchaseModule';
import { UsersModule } from './dashboard/UsersModule';
import { ReportsModule } from './dashboard/ReportsModule';
import { DeliveryModule } from './dashboard/DeliveryModule';
import { ZoneModule } from './dashboard/ZoneModule';
import { BranchesModule } from './dashboard/BranchesModule';
import { WarehouseModule } from './dashboard/WarehouseModule';
import { TransportModule } from './dashboard/TransportModule';
import { EmergencyModule } from './dashboard/EmergencyModule';
import { AppointmentsModule } from './dashboard/AppointmentsModule';
import { CustomerFeedbackModule } from './dashboard/CustomerFeedbackModule';

export const OrgAdminDashboard = ({ org, user }) => {
  const { version: dataVersion } = useSharedStore();

  const totalRevenue = useMemo(() => {
    return salesOf(org.id).reduce((s, x) => s + (Number(x.total) || 0), 0);
  }, [org.id, dataVersion]);

  const isService = org.type === ORG_TYPES.SERVICE || org.type === ORG_TYPES.BOTH;
  const isProduct = org.type === ORG_TYPES.PRODUCT || org.type === ORG_TYPES.BOTH;

  return (
    <div className="flex flex-col gap-2 pb-6 origin-top" style={{ zoom: 0.85 }}>

      {isModuleOn(org, 'emergency') && <EmergencyModule org={org} />}
      
      {/* Universal Modules (Put POS first as requested) */}
      <PosModule org={org} />
      
      {/* Service-Specific Modules */}
      {isService && isModuleOn(org, 'appointments') && <AppointmentsModule org={org} />}
      {isService && isModuleOn(org, 'feedback') && <CustomerFeedbackModule org={org} />}
      
      <CatalogModule org={org} />
      
      {/* Product-Specific Modules */}
      {isProduct && isModuleOn(org, 'inventory') && <InventoryModule org={org} />}
      {isProduct && isModuleOn(org, 'purchase') && <PurchaseModule org={org} />}
      {isProduct && isModuleOn(org, 'warehouse') && <WarehouseModule org={org} />}
      {isProduct && isModuleOn(org, 'transport') && <TransportModule org={org} />}
      {isProduct && isModuleOn(org, 'delivery') && <DeliveryModule org={org} />}
      
      {/* Other Shared Modules */}
      {isModuleOn(org, 'users') && <UsersModule org={org} />}
      {isModuleOn(org, 'reports') && <ReportsModule org={org} />}
      {isModuleOn(org, 'zone') && <ZoneModule org={org} />}
      {isModuleOn(org, 'branches') && <BranchesModule org={org} />}
    </div>
  );
};

OrgAdminDashboard.propTypes = {
  org: PropTypes.object.isRequired,
  user: PropTypes.object,
};

